import { WarningIcon } from '../../../Icons/warning';
import { TEXT_INPUT_PROPS } from './Utils/types';

export const TextInput = ({
  id,
  label,
  errors,
  onTextChangeFn,
  onBlurFn,
  placeholder,
  value,
  showLabel = false,
  type = 'text',
  required = false,
}: TEXT_INPUT_PROPS): JSX.Element => {
  const hasError = errors?.touched && errors?.error;

  return (
    <div className="pb-5 sm:pb-4">
      <label
        htmlFor={id}
        className={`text-base text-font-200 font-medium sm:text-s-14 ${
          showLabel ? '' : 'hidden'
        }`}
      >
        {label} {required && <span className="text-red-350">*</span>}
      </label>

      <div className="flex relative">
        <input
          id={id}
          type={type}
          className={`border border-gray-200 rounded-sm mt-1 text-base w-full h-12 px-2 placeholder-gray-400 placeholder-opacity-75 sm:text-s-14 sm:h-10 ${
            hasError ? 'border-[#E8723B]' : ''
          }`}
          placeholder={`${placeholder} ${required ? '*' : ''}`}
          name={id}
          value={value}
          onChange={onTextChangeFn}
          onBlur={onBlurFn}
        />
        <div className="absolute right-2 top-3.5 sm:top-2.5">
          {hasError ? <WarningIcon /> : null}
        </div>
      </div>

      {hasError ? (
        <p className="text-[#E8723B] text-s-12 font-semibold inline-block">
          {errors?.message}
        </p>
      ) : null}
    </div>
  );
};
